const domainBlacklist = ['farmoaks.com']

export default domainBlacklist
